import Marquee from 'react-fast-marquee';
import { MARQUEE_ITEMS } from '../data/content';

export const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative z-10 bg-[#FF5C00] py-4 md:py-5 -rotate-1 scale-[1.02] my-2"
  >
    <Marquee speed={32} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((item, i) => (
        <span
          key={i}
          className="font-display font-semibold uppercase tracking-[0.15em] text-[#0A1128] text-sm md:text-base mx-6 flex items-center gap-12"
        >
          {item}
          <span className="inline-block w-2 h-2 rotate-45 bg-[#0A1128]" />
        </span>
      ))}
    </Marquee>
  </div>
);
